unit Web.Format.Utils;

interface

function FormatCurrencyGbp(AValue: Double; AIsNull: Boolean): string;

implementation

uses
  System.SysUtils;

function FormatCurrencyGbp(AValue: Double; AIsNull: Boolean): string;
begin
  if AIsNull then
    Result := ''
  else
    Result := FormatFloat('£#,##0.00', AValue);

end;

end.
